import { Formik } from 'formik'
import React from 'react'
import { Alert, Collapse } from 'reactstrap'
import toast from 'react-hot-toast'
import useTranslation from '../hooks/UseTranslation'

const AsyncForm = ({ children, onSubmit, isPromise = true, ...props }) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState()

  const submit = (...data) => {
    if (isLoading) return
    setError(null)
    setIsLoading(true)
    if (isPromise) {
      const toastId = toast.loading(t('pending_generic'))
      return onSubmit(...data)
        .then(() => toast.success(t('modal_title_success'), { id: toastId }))
        .catch((e) => {
          console.error(e)
          if (typeof e.response?.data?.detail === 'string') {
            setError(e.response?.data?.detail)
            toast.dismiss(toastId)
          } else {
            toast.error(t('modal_title_there_was_an_issue'), { id: toastId })
          }
        })
        .finally(() => setIsLoading(false))
    }
    try {
      return onSubmit(...data)
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Formik onSubmit={submit} {...props}>
      {(formProps) => (
        <>
          {children(isLoading, formProps)}
          <Collapse isOpen={!!error}>
            <div>
              <Alert color='danger' className='mt-2'>
                {error}
              </Alert>
            </div>
          </Collapse>
        </>
      )}
    </Formik>
  )
}

export default AsyncForm
